import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconMenu$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconMenu extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '3b020d1270f9f7c883e6058e4538a5a5fc652e11', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '13e5757712301947601bfee2420417129efa62ce', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '40b2a36141bec7f592fe0256ca4101b15669d436', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3 5.5a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 .5.5V6a.5.5 0 0 1-.5.5h-15A.5.5 0 0 1 3 6zm0 5.25a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-15a.5.5 0 0 1-.5-.5zm.5 4.75a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5V16a.5.5 0 0 0-.5-.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-menu", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-menu"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-menu":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconMenu$1);
            }
            break;
    } });
}

const CosmosIconMenu = CosmosIconMenu$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconMenu, defineCustomElement };
